import React, { Component } from 'react';
import { getGameTime } from './Utils.js';

class GameStatsKills extends Component {
    render() {
        let {data} = this.props;
        let numChars = Object.keys(data.characters).length;
        let colors = numChars === 2 ? ["p2", "p1"] : ["ts-p3", "ts-p4", "ts-p1", "ts-p2"];
        let swapPlayers = numChars === 2 ? [2, 1] : [3, 4, 1, 2];

        let kills = data["all_kills"].map(function(value, i) {
            let player = 'P' + swapPlayers[value["killer"]];
            let killed = 'P' + swapPlayers[value["target"]];
            let data = [];
            let playerColor = colors[swapPlayers[value["killer"]]-1];
            let killedColor = colors[swapPlayers[value["target"]]-1];

            data.push(<td key={"kill-c1-"+i} className={playerColor}>{player}</td>);
            data.push(<td key={"kill-c2-"+i} className={killedColor}>{killed}</td>);
            data.push(<td key={"kill-c3-"+i}>{getGameTime(value["time"])}</td>);
            data.push(<td key={"kill-c4-"+i}>{value["fall_percent"]}%</td>);
            data.push(<td key={"kill-c5-"+i}>{value["rage_percent"]}%</td>);
            return <tr key={"kill-" + i} >{data}</tr>;
        }, this);

        return (
            <div className="kills">
              <h3>Kills</h3>
              <table>
                <tbody>
                  <tr><th>Player</th><th>Killed</th><th>Time</th><th>Percent</th><th>Rage</th></tr>
                  {kills}
                </tbody>
              </table>
            </div>
        );
    }
}

export default GameStatsKills;
